import { CellField } from '@/components/custom/erp/input-table-v2';
import { roundNumber } from '@/lib/formatUtils';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  tongSoLuong?: number;
  tongTienNt2?: number;
  tongChietKhau?: number;
  tongThue?: number;
}

function BottomBar({ tongSoLuong = 0, tongTienNt2 = 0, tongChietKhau = 0, tongThue = 0 }: BottomBarProps) {
  const tongThanhToan = Number(tongTienNt2) + Number(tongThue);
  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='flex flex-col'>
          {/* Column 1 */}
          <div className='flex items-center'>
            <Label className='w-28 font-semibold'>Tổng số lượng</Label>
            <div className='w-[100px] pb-1'>
              <CellField className='border-b' name='t_so_luong' type='number' value={Number(tongSoLuong)} />
            </div>
          </div>
        </div>

        <div className='ml-8 flex flex-col'>
          <div className='flex items-center'>
            <Label className='w-24 font-semibold'>Tổng tiền</Label>
            <CellField name='t_tien_nt' type='number' value={roundNumber(tongTienNt2, 0)} className='w-40 border-b' />
          </div>
          <div className='flex items-center'>
            <Label className='w-24 font-semibold'>Tổng thuế</Label>
            <CellField name='t_thue_nt' type='number' value={roundNumber(tongThue, 0)} className='w-40 border-b' />
          </div>
        </div>

        <div className='ml-auto flex w-1/4 flex-col'>
          {/* Column 3 */}
          <div className='flex items-center'>
            <Label className='w-32 font-semibold'>Tổng chiết khấu</Label>
            <CellField name='t_tien_nt' type='number' value={roundNumber(tongChietKhau, 0)} className='w-40 border-b' />
          </div>
          <div className='flex items-center justify-start'>
            <Label className='w-32 font-semibold'>Tổng thanh toán</Label>
            <CellField name='t_tt_nt' type='number' value={roundNumber(tongThanhToan, 0)} className='w-40 border-b' />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
